import { ACCESS_REQUEST, INVITE } from '@src/const';
import { mogamboRequestV3 } from '@src/api/utils';

export const inviteYourFriendRequest = (email, botId) => {
  const url = `${ACCESS_REQUEST}${INVITE}`;
  return mogamboRequestV3(url, 'POST', {
    /* 
      It's a reusable API, so if send invite is for some other page we will use a different UUID which in turn will redirect the user to a different URL
      We want to have UUID to know that which url we want it redirect to
      UUID handles both redirection and access control
      We are calling it access_profile_id because
      Invited users are invited with a certain roles in the application and hence they are given a specific set of things they can access which makes it an access profile
    */
    access_profile_id: '88cf0061-e2f4-4cd9-9cbb-9743246c8768',
    expert_email: email,
    metadata: {
      bot_id: botId,
    },
  });
};
